<template>
    <div class="cart-block">
        <div class="cart-block-item">
            <cart-card/>
        </div>
        <div class="cart-block-item">
            <cart-card/>
        </div>
        <div class="cart-block-total">
            <div class="price">
                <div class="title">Всего:</div>
                <div class="sum">
                    <span>35 543</span>
                <span>грн.</span>
                </div>
            </div>
            <button @click="goToRoute">Оформить</button>
        </div>
    </div>
</template>

<script>
    import CartCard from "../Cards/CartCard";
    export default {
        name: "Cart",
        components: {CartCard},
        methods: {
            goToRoute() {
                this.$router.push('checkout');
            }
        }
    }
</script>

<style scoped lang="scss">
    .cart-block {
        background: #FCFCFC;
        width: 385px;

        box-shadow: 0 15px 20px rgba(0, 0, 0, 0.04);
        &-item {
            &:not(:last-child) {
                border-bottom: 1px solid #EEF2F6;
            }
        }
        &-total {
            border-top: 1px solid #EEF2F6;
            padding: 17px 16px;
            display: flex;
            justify-content: space-between;
            .price {
                display: flex;
                align-items: center;
                .title {
                    font-size: 16px;
                    line-height: 25px;
                    color: #3F4450;
                    min-width: 60px;
                    margin-right: 10px;
                }
                .sum {
                    span {
                        color: #3FB0AB;
                        font-size: 14px;
                        line-height: 21px;
                        &:first-child {
                            font-size: 22px;
                            line-height: 34px;
                        }
                    }
                }
            }
            button {
                background: linear-gradient(80.98deg, #7AC3C1 0%, #3FB0AB 100%);
                border: none;
                border-radius: 5px;
                color: #FCFCFC;
                font-size: 16px;
                padding: 8px 24px;
                cursor: pointer;
            }
        }
    }
</style>
